export default "__VITE_ASSET__BuJCNq6H__"